import React from 'react';
import logo from '../../assets/checking-year/bacchus-drinks-logo.svg'
import LanguageSelect from "../../common/LanguageSelect";
import { useTranslation } from "react-i18next";
import { 
  Background, 
  BackgroundOverlay, 
  Logo, 
  Title, 
} from '../CheckingYear/styles';
import { 
  LanguageWrapper
} from '../CheckingYear/styles';

const CheckingYear = () => {
  const { t } = useTranslation();

  return (
    <Background>
      <BackgroundOverlay>
        <Logo src={logo} />
        <Title>{t("sorryYouMust")}</Title>
        <LanguageWrapper>
          <LanguageSelect/>
        </LanguageWrapper>
      </BackgroundOverlay>
    </Background>
  );
}

export default CheckingYear;
